import React from 'react'
import './TitleContentSection.css'

const TitleContentSection = (props) => (
    <div className="Section">
        <h2 className="Section-Title">{props.title}</h2>
        <hr className="Section-Divider" />

        { props.children == null ? 
            <h3 className="Section-Content">{props.content}</h3>
            : props.children}
            
    </div>
)

export default TitleContentSection


// WEBPACK FOOTER //
// ./src/components/titlecontentsection/TitleContentSection.js